import React, { useState } from 'react';
import ImageCarousel from './ImageCarousel';
import GRID_IMAGES, { GRID_PREVIEW_COUNT } from '../data/gridImages';

function ImageGrid() {
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const previewImages = GRID_IMAGES.slice(0, GRID_PREVIEW_COUNT);

  return (
    <>
      <div className="image-grid" role="list">
        {previewImages.map((image, index) => (
          <button
            key={`${image.alt}-${index}`}
            type="button"
            className="image-grid__item"
            style={{ '--img-position': image.position }}
            onClick={() => setLightboxIndex(index)}
            aria-label={`View ${image.alt}`}
          >
            <img src={image.src} alt={image.alt} loading="lazy" />
          </button>
        ))}
      </div>

      {lightboxIndex !== null && (
        <ImageCarousel
          images={GRID_IMAGES}
          currentIndex={lightboxIndex}
          onClose={() => setLightboxIndex(null)}
          onNavigate={setLightboxIndex}
        />
      )}
    </>
  );
}

export default ImageGrid;
